import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelAccountsEditFeePlansResolverErrorStatesEnum {
    GetFeeGroupsFailed = ErrorStateScheduleEnum.PanelAccountsEditFeePlansResolverErrorStatesStartIndex,
    GetFeeGroupsNotFound,
    GetFeeTypesFailed,
    GetFeeTypesNotFound
}
